module.exports = __webpack_public_path__ + "img/title5.2fa03c0c.png";